import React from 'react';

import App from '../App';

const Resume = () => (
    <App>
        <article className="post" id="index">
        <header>
            <div className="title">
            <h2>Resume</h2>
            </div>
        </header>
        <p>Click <a href="__files/WeijiaSunP.pdf" target="_blank" rel="noopener noreferrer">here</a> for Resume</p>
        </article>
    </App>
);

export default Resume;


// WEBPACK FOOTER //
// ./src/app/views/Resume.js